import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  BaseAppState,
  CancerTherapyType,
  CancerType,
  ModalsActions,
  User,
  getLoggedInUser,
} from 'ngx-esprio-shared';

/**
 * Dashboard card (ticket: therapy type editable). Shows the user's current
 * therapy type(s) and cancer type(s). The therapy section is editable via a
 * modal and, per therapy type, shows a link; when no therapy is set it prompts
 * the user to enter one. The cancer section is display-only.
 */
@Component({
  selector: 'app-therapy-info-card',
  templateUrl: './therapy-info-card.component.html',
  styleUrls: ['./therapy-info-card.component.scss'],
})
export class TherapyInfoCardComponent {
  public user$ = this.store.select(getLoggedInUser);

  // Placeholder link — reuses the protein card's link until the real WebK
  // therapy/tumor pages are available (one per therapy type).
  public readonly infoLink = 'https://www.was-essen-bei-krebs.de/eiweiss';

  public constructor(private readonly store: Store<BaseAppState>) {}

  /** Therapy types the user actually set (excludes the "unknown" placeholder). */
  public therapyTypesOf(user: User | null): CancerTherapyType[] {
    return (user?.coreData?.therapyTypes ?? []).filter(
      (type) => type !== CancerTherapyType.Unknown
    );
  }

  /** Cancer types the user actually has (excludes the "unknown" placeholder). */
  public cancerTypesOf(user: User | null): CancerType[] {
    return (user?.coreData?.cancerTypes ?? []).filter((type) => type !== CancerType.Unknown);
  }

  public handleChangeTherapyClick(): void {
    this.store.dispatch(ModalsActions.OpenTherapyTypeModal());
  }
}
